/**
 * Authentication related constants
 */

// OTP related time (unit: seconds)
export const OTP_VERIFICATION_TIMEOUT = 300; // OTP code validity period: 5 minutes
export const OTP_RESEND_COOLDOWN = 60; // Cooldown time for resending OTP: 60 seconds

// Password validation rules
export const PASSWORD_MIN_LENGTH = 8; // Minimum password length
export const PASSWORD_PATTERN = {
  uppercase: /[A-Z]/, // At least 1 uppercase letter
  lowercase: /[a-z]/, // At least 1 lowercase letter
  number: /\d/, // At least 1 digit
};

// Email validation rules
export const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

// OTP code format
export const OTP_CODE_LENGTH = 6; // OTP code length: 6 digits
export const OTP_CODE_PATTERN = /^\d{6}$/; // OTP code must be 6 digits
